export const colors = {
  black: "rgba(29, 29, 29, 1)",
  border: "rgba(29, 29, 29, 0.6)",
  headerColor: "rgba(134, 139, 158, 1)",
  lightBlack: "rgba(30, 30, 33, 0.95)",
  blueGradient:
    "linear-gradient(178.89deg, #1F3DB6 14.22%, #2345CA 36.3%, #355AEE 99.05%)",
  redGradient:
    "linear-gradient(178.89deg, #DB2E2E 14.22%, #E43030 36.3%, #F84444 99.05%)",
  greenGradient:
    "linear-gradient(178.89deg, #28A909 14.22%, #309B17 69.01%, #208707 99.05%);",
  primaryGrey: "rgba(41, 41, 48, 0.9);",
  secondaryGrey: "#363640",
  lightGrey: "#868B9E",
  blue: "#1F3DB5",
  red: "#DB2E2E",
  green: "#208707",
  notificationBackground: "rgba(49, 91, 237, 0.2)",
  notificationText: "rgba(49, 91, 237, 1)",
  errorBackground: "rgba(223, 46, 46, 0.2)",
  errorText: "rgba(223, 46, 46, 1)",
  prevRoundRed: "rgba(225, 12, 12, 0.6)",
  prevRoundGray: "rgba(142, 163, 248, 0.6)",
  prevRoundGreen: "rgba(111, 113, 37, 0.6)",
  prevRoundCarrot: "rgba(255, 129, 57, 0.6)",
  prevRoundBlue: "rgba(0, 26, 255, 0.6)",
  winBoxBackground: "rgba(42, 165, 12, 0.3)",
  liveBetsGreen: "#91A63E",
  liveBetsDarkGreen: "#46603D",
  liveBetsPrevRoundCoef: "rgba(225, 12, 12, 0.6);",
  liveScoreBackground: "rgba(54, 54, 64, 0.5);",
  liveScoreText: "#C4C9DD;",
  liveScoreWinner: "rgba(82, 92, 39, 0.6);",
  liveBetsBackground: "rgba(145, 166, 62, 0.3)",
  progressBarBackground: "#181E34",
  audioText: "#868B9E",
  audioBackground: "#25252B",
  audioBlueGradient:
    "linear-gradient(178.89deg, #1F3DB6 14.22%, #2345CA 36.3%, #355AEE 99.05%)",
  audioRedGradient:
    "linear-gradient(178.89deg, #DB2E2E 14.22%, #E43030 36.3%, #F84444 99.05%);",
  historyBackgroundWin: "#91A63E",
  historyBackgroundLoose: "rgb(50, 50, 59)",
  historyLooseParagraph: "rgb(196, 201, 221)",
  historyWinParagraph: "rgb(211, 234, 215)",
  historyWinHeader: "rgb(149, 203, 157)",
  historyLooseHeader: "rgb(96, 101, 121)",
  settingsTabletTopBg: "rgba(30, 30, 33, 0.95)",
  settingsTabletBottomBg: "rgba(37, 37, 43, 0.95)",
  settingsTableInnerHeader: "rgba(41, 41, 48, 0.9);",
  solar: {
    title: "#C9D8C5",
    gradient: "linear-gradient(27.03deg, #B6961E 29.02%, #FFCB05 84%);",
    shadow: "inset 0px -3px 0px #836B0E;",
  },
  galactical: {
    title: "#C6BEF4",
    gradient:
      "linear-gradient(178.89deg, #1F3DB6 14.22%, #2345CA 36.3%, #355AEE 99.05%);",
    shadow: "inset 0px -3px 0px #1F3DB5;",
  },
  stellar: {
    title: "#D9BFC0",
    gradient:
      " linear-gradient(178.89deg, #DB2E2E 14.22%, #E43030 36.3%, #F84444 99.05%);",
    shadow: " inset 0px -3px 0px #D82E2E;",
  },
  jackpotWinBlue: "rgba(68, 68, 243, 1)",
  jackpotWinBlueBackground: "rgba(64, 63, 243, 0.3)",
  jackpotWinRed: "rgba(229, 82, 82, 1)",
  jackpotWinRedBackground: "rgba(225, 73, 73, 0.3)",
  jackpotWinYellow: "rgba(246, 131, 27, 1)",
  jackpotWinYellowBackground: "rgba(245, 126, 29, 0.3)",
}
